import { Button } from "@/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";

type ConfirmDeleteModalProps = {
  isOpen: boolean;
  itemName: string;
  itemLabel?: string;
  onClose: () => void;
  onConfirm: () => void;
};

/**
 * Generic confirmation modal for delete operations
 * Can be reused across different features for confirming deletions
 */
const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  itemName,
  itemLabel = "item",
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-backgroundcolor">
        <DialogHeader>
          <DialogTitle className="text-white">Confirm Delete</DialogTitle>
        </DialogHeader>
        <div className="text-white75">
          <p>
            Are you sure you want to delete this {itemLabel}
            {itemName ? `: "${itemName}"` : ""}?
          </p>
          <p className="mt-2">This action cannot be undone.</p>
        </div>
        <DialogFooter className="flex sm:justify-between">
          <Button
            variant="outline"
            onClick={onClose}
            className="mt-4 sm:mt-0 hover:bg-gray-700 text-white"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-500 text-white mt-4 sm:mt-0"
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
